import React from 'react';
import { Collapse, CollapsePanelProps, CollapseProps } from 'antd';

import './index.less';
import { MAIN_CLASS_NAME, PANEL_CLASS_NAME } from './const';

type IIbCollapseProps = CollapseProps;

const IbCollapse: React.FC<IIbCollapseProps> = ({ children, className, ...otherProps }) => {
  const classes = [MAIN_CLASS_NAME];
  className && classes.push(className);
  return (
    <Collapse accordion {...otherProps} className={classes.join(' ')}>
      {children}
    </Collapse>
  );
};

type IIbCollapsePanelProps = CollapsePanelProps;

const IbCollapsePanel: React.FC<IIbCollapsePanelProps> = ({ children, className, ...otherProps }) => {
  const classes = [PANEL_CLASS_NAME];
  className && classes.push(className);
  return (
    <Collapse.Panel {...otherProps} className={classes.join(' ')}>
      {children}
    </Collapse.Panel>
  );
};

export { IbCollapsePanel };
export default IbCollapse;
